(async function(algolia) {
    'use strict';
    if (!algolia.config.autocomplete_enabled) return;

    algolia.searchClient = algolia.searchClient || algolia.externals.algoliasearch(algolia.config.app_id, algolia.config.search_api_key);
  
    const autocomplete = algolia.externals.autocomplete;
    const { createRedirectUrlPlugin } = window['@algolia/autocomplete-plugin-redirect-url'];
    const { createQuerySuggestionsPlugin } = window['@algolia/autocomplete-plugin-query-suggestions'];
    const getAlgoliaResults = algolia.externals.getAlgoliaResults;

    algolia.searchClient.addAlgoliaAgent('Shopify Integration');
  
    if (algolia.config.dynamic_selector) {
      const search_url = algolia?.shopify?.routes?.search_url || `${window.Shopify.routes.root}/search`;
      const default_form_search = `form[action="${search_url}"]`;
      algolia.config.input_selector += `, ${default_form_search}`;
    }
    
    // Retrieve the container from Shopify's config
    const containers = Array.from(document.querySelectorAll(algolia.config.input_selector));
    containers.forEach(container => {
      container.innerHTML = ''
      const containerClasses = container.classList;
      containerClasses.add('aa-MainContainer');
    });
  
    //redirect plugin
    const redirectUrlPlugin = createRedirectUrlPlugin();
    //query suggestions plugin
    const querySuggestionsPlugin = algolia.config.query_suggestions_index_name && 
    createQuerySuggestionsPlugin({
      searchClient: algolia.searchClient,
      indexName: algolia.config.query_suggestions_index_name,
    });
    // Set plugins
    const { productsPlugin, collectionsPlugin, articlesPlugin, pagesPlugin} = algolia;
    // No sources: the panel is never opened (see shouldPanelOpen below), so
    // querying Algolia here would burn operations and skew Algolia analytics.
    const plugins = [];
  
    const cssFile = document.getElementById('template_algolia_autocomplete.css');
    //Set CSS variables
    document.documentElement.style.setProperty(`--aa-text-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.secondary)}`);
    document.documentElement.style.setProperty(`--aa-primary-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.main)}`);
    document.documentElement.style.setProperty(`--aa-muted-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.muted)}`);
    document.documentElement.style.setProperty(`--aa-highlight-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
    //Link CSS
    algolia.appendStyle(cssFile.text);
  
    const autocompleteOptions = {
      openOnFocus: false,
      // Marqo owns storefront search on this theme. Keep the Autocomplete mount
      // (it creates the only header search input, which Marqo instant search
      // binds to) but never open the Algolia suggestions panel.
      shouldPanelOpen: () => false,
      debug: algolia.config.autocomplete_debug,
      insights: algolia.config.analytics_enabled,
      detachedMediaQuery:'none',
      plugins,
      placeholder: algolia.translations.searchForProduct,
      render({ elements, render, html, state }, root) {
        const nonEmptyCollections = state.collections.filter(({ source, items }) => items.length > 0 && source.sourceId === "collections")
        const displayCollections = nonEmptyCollections.length > 0;

        const querySuggestionsPluginResults = state.collections.find(
                ({ source }) => source.sourceId === 'querySuggestionsPlugin'
        );
        const displaySuggestions = algolia.config.autocomplete_query_suggestions &&
                (querySuggestionsPluginResults?.items?.length ?? 0) > 0;

        render(
                displayCollections || displaySuggestions ?
                algolia.mainTemplate({ html, state }, elements, displaySuggestions)
                : algolia.mainProductsTemplate({ html, state }, elements),
                root
        );
      },
      renderNoResults({ render, html, state }, root) {
        render(
                algolia.noResultsTemplate({ html, state }),
                root
        )
      },
      onSubmit({ state }) {
        window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(state.query)}`;
      }
    }
    containers.forEach(container => {
      autocomplete({
        container,
        ...autocompleteOptions
      });
    });
  })(window.algoliaShopify);